import { render, staticRenderFns } from "./addOperations.vue?vue&type=template&id=270845e6&"
import script from "./addOperations.vue?vue&type=script&lang=js&"
export * from "./addOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270845e6')) {
      api.createRecord('270845e6', component.options)
    } else {
      api.reload('270845e6', component.options)
    }
    module.hot.accept("./addOperations.vue?vue&type=template&id=270845e6&", function () {
      api.rerender('270845e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/addOperations.vue"
export default component.exports